<template>
    <a :href="to" :target="target" rel="noopener noreferrer">
        <slot />
    </a>
</template>

<script>
// 外部链接
export default {
    name: 'ExternalLink',
    props: {
        to: {
            type: String,
            default: ''
        },
        target: {
            type: String,
            default: '_blank'
        }
    }
};
</script>

<style></style>
